import React from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import FieldDescriptionEditor_Component from "../components/editor";

export default function FieldDescriptionEditor_FormElementView(props:FieldFormElementViewProps) {

    const disabled = _.get(props.options, 'disabled', false)
    const value = props.model[props.field.fieldId]

    return <FieldDescriptionEditor_Component className = {props.className}
                          field     = {props.field}
                          value     = {value}
                          disabled  = {disabled}
                          onChange  = {props.onChange}/>

}